module.exports = __webpack_public_path__ + "media/images/pic/hero/team-ae906777ea38ae11608adf33d0604383.webp";